
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class PendingOrderJobSettingsDialog extends Serenity.EntityDialog<PendingOrderJobSettingsRow, any> {
        protected getFormKey() { return PendingOrderJobSettingsForm.formKey; }
        protected getIdProperty() { return PendingOrderJobSettingsRow.idProperty; }
        protected getLocalTextPrefix() { return PendingOrderJobSettingsRow.localTextPrefix; }
        protected getNameProperty() { return PendingOrderJobSettingsRow.nameProperty; }
        protected getService() { return PendingOrderJobSettingsService.baseUrl; }
        protected getDeletePermission() { return PendingOrderJobSettingsRow.deletePermission; }
        protected getInsertPermission() { return PendingOrderJobSettingsRow.insertPermission; }
        protected getUpdatePermission() { return PendingOrderJobSettingsRow.updatePermission; }

        protected form = new PendingOrderJobSettingsForm(this.idPrefix);

    }
}